export const deepSort = <T extends object | unknown[]>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj
      .map((item) => (Array.isArray(item) ? deepSort(item) : item))
      .sort() as T;
  } else if (typeof obj === "object") {
    const sorted = {};
    Object.keys(obj)
      .sort()
      .forEach((key) => {
        sorted[key] = deepSort(obj[key]);
      });
    return sorted as T;
  } else {
    return obj;
  }
};
